<script setup>
import NewFeeTabsPage from '@/components/operational/newFee/NewFeeTabsPage.vue'
import { useFeeRuleSet } from '@/components/operational/newFee/useFeeRuleSet'

import FeeConfigurationContent from './components/FeeConfigurationContent.vue'

const route = useRoute()
const router = useRouter()

const { feeVersions, feeRuleSetId, feeRuleSetRoot, initialLoading, load } = useFeeRuleSet()

// Platform fee 不绑定具体 Master，ma_id 传空字符串
const loadPlatformFeeRuleSet = () => load('')

onMounted(loadPlatformFeeRuleSet)

// 搜索框选中 Master 后跳转到 Master fee，并把选中值与展示文案一起带过去
const openSelectedMaster = ({ value, label, holderName }) => {
  router.push({
    name: 'operational-new-fee-master-fee',
    query: {
      ...route.query,
      masterId: value,
      masterLabel: label,
      masterName: holderName,
    },
  })
}

definePage({
  name: 'operational-new-fee-platform-fee',
  path: '/operational/newFee/platform-fee',
  meta: {
    action: 'read',
    subject: 'Fee',
    navActiveLink: 'operational-new-fee',
  },
})
</script>

<template>
  <NewFeeTabsPage
    active-tab="platform-fee"
    :loading="initialLoading"
  >
    <FeeConfigurationContent
      show-master-search
      :versions="feeVersions"
      :rule-set-id="feeRuleSetId"
      :rule-set-root="feeRuleSetRoot"
      @master-selected="openSelectedMaster"
      @draft-saved="loadPlatformFeeRuleSet"
      @published="loadPlatformFeeRuleSet"
      @draft-created="loadPlatformFeeRuleSet"
    />
  </NewFeeTabsPage>
</template>
